import React from 'react';

function Header() {
  return (
    <div className='ui fixed menu'>
        <div className='ui container center'>
            <h2>ShopKart</h2>
        </div>
    </div>
  )
}

export default Header;